function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTriggerCompleted = function SvgTriggerCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4060"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4061"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4057"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2401.127-3399.342a8.772 8.772 0 0 1-1.715-.169 8.752 8.752 0 0 1-4.5-2.406 8.762 8.762 0 0 1-2.4-4.5 8.762 8.762 0 0 1 .5-5.078 8.764 8.764 0 0 1 3.239-3.942 8.762 8.762 0 0 1 4.829-1.478h.054a8.74 8.74 0 0 1 6.206 2.58 8.736 8.736 0 0 1 2.575 6.207 8.754 8.754 0 0 1-1.48 4.882 8.761 8.761 0 0 1-3.944 3.236 8.749 8.749 0 0 1-3.364.668zm0-15.979a7.235 7.235 0 0 0-5.08 2.1 7.137 7.137 0 0 0-2.1 5.083 7.141 7.141 0 0 0 2.108 5.082 7.141 7.141 0 0 0 5.082 2.1 7.154 7.154 0 0 0 5.078-2.107 7.038 7.038 0 0 0 2.068-4.346c.032-.436.038-.583.038-.728a7.139 7.139 0 0 0-2.1-5.084 7.14 7.14 0 0 0-5.083-2.108z",
    "data-name": "Subtraction 8",
    style: {
      fill: "#40ce66"
    },
    transform: "translate(2412.126 3419.128)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m813.987 902.726-3.6 3.7-1.8-1.8a.906.906 0 0 0-1.249 1.249l2.448 2.448a.868.868 0 0 0 1.249-.006l4.246-4.371a.906.906 0 0 0-.65-1.593.823.823 0 0 0-.644.373z",
    "data-name": "Path 11723",
    style: {
      fill: "#40ce66"
    },
    transform: "translate(-800.3 -894.016)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 4461",
    style: {
      fill: "none"
    }
  }));
};
export default SvgTriggerCompleted;